import React from 'react';
export const ConditionalWrapper = ({ wrap, elseWrap, condition, children })=>/*#__PURE__*/ React.createElement(React.Fragment, null, condition && wrap ? wrap(children) : elseWrap ? elseWrap(children) : children);
ConditionalWrapper.displayName = 'ConditionalWrapper';
export default ConditionalWrapper;
